import { cn } from '@/utils'
import { MaskedNumber } from './MaskedNumber'
import { MemberCardRow } from './MemberCardRow'
import type { MapLane } from './map'
import { LABEL_COLUMN, LANE_ROW, TIMELINE_COLUMN } from './mapLayout'
import type { Highlight } from './mapView'

interface MemberCardsProps {
  members: MapLane[]
  // Its primary card was filtered off the map, so the group opens its own section.
  standsAlone: boolean
  highlight: Highlight
  openStatementId: string | null
  onOpenSegment: (segmentId: number) => void
}

// The extra cards on one credit account, named once as a group and indented under the card whose
// statements carry their spending.
export const MemberCards = ({
  members,
  standsAlone,
  ...shared
}: MemberCardsProps) => (
  <>
    <div className={LANE_ROW}>
      <div className={cn(LABEL_COLUMN, 'pb-2', standsAlone && 'pt-10')}>
        <div className="ml-1 text-[11px] font-medium leading-4 text-violet-700">
          Member cards on <MaskedNumber number={members[0]?.memberOf ?? ''} />
        </div>
      </div>
      <div className={TIMELINE_COLUMN} />
    </div>
    {members.map((member) => (
      <MemberCardRow key={member.accountId} lane={member} {...shared} />
    ))}
  </>
)
